module.exports = __webpack_public_path__ + "img/seafood-sushi-rise.f5bb33f7.svg";